export default [
  {
    path: '/official-20250722-main',
    component: () => import('./Page.vue'),
    meta: { id: 143, title: '小游戏排行榜' },
  },
]
